export default "__VITE_ASSET__DL_Wl53$__"